/* eslint-disable */
import { env } from 'src/config/env';

(function () {
  var w = window; 
  var ic = w.Intercom; 
  
  if (typeof ic === "function") { 
    ic('reattach_activator'); 
    ic('update', { app_id: env.INTERCOM_APP_ID, hide_default_launcher: false });
  } else {
    var d = document; 
    var i = function () { i.c(arguments) }; 
    i.q = []; 
    i.c = function (args) { i.q.push(args) }; 
    w.Intercom = i; 
    
    function l() {
      var s = d.createElement('script'); 
      s.type = 'text/javascript'; 
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/' + env.INTERCOM_APP_ID;
      s.onload = function() {
        w.Intercom('boot', { app_id: env.INTERCOM_APP_ID, hide_default_launcher: false });
      };
      var x = d.getElementsByTagName('script')[0]; 
      x.parentNode.insertBefore(s, x);
    } 
    
    if (w.attachEvent) { 
      w.attachEvent('onload', l); 
    } else { 
      w.addEventListener('load', l, false); 
    }
  }
})()
/* eslint-enable */
